import React, { useState, useContext, useEffect, useRef } from 'react';
import { Page, Spinner, Icon } from 'components';
import classNames from 'lib/classNames';
import ShopContext from 'context/ShopContext';
import UserContext from 'context/UserContext';
import { API_GATEWAY, APP_DEV } from 'aws-exports';
import { API } from 'aws-amplify';
import moment from 'moment';
import { SAVE_PLAN_SETTINGS } from 'lib/mutations';
import { useMutation } from '@apollo/react-hooks';
import { GET_SHOP_SETTINGS } from 'Queries';
import { Loading, Toast } from '@shopify/app-bridge-react';
import useRefState from 'hooks/useRefState';
import getPlans from 'lib/getPlans';

// ⛔⛔ do not remove
// this classes for the css purge  
// border-teal-500
// border-blue-500
// border-indigo-500
// border-purple-500
// bg-teal-500
// bg-blue-500
// bg-indigo-500
// bg-purple-500
// text-teal-500
// text-blue-500
// text-indigo-500
// text-purple-500

const PlanScreen = () => {
	const [loading, setLoading] = useState(true);
	const [plan, setPlan] = useState(null);
	const [currentPlan, setCurrentPlan] = useState(null);
	const user = useContext(UserContext);
	const shopContext = useContext(ShopContext);
	const { state: shop } = shopContext;
	const plans = getPlans(new Date(shop.installedAt).getTime());
	const hasDiscount = shop?.invitation && shop?.invitation?.type === 'discount_percentage' && shop?.invitation?.value
	const discount = hasDiscount ? shop.invitation.value / 100 : 0 
	const applyDiscount = (value) => Number((value - (value * discount)).toFixed(2))
	const getPlan = async () => {
		const planResponse = await API.get('API_GATEWAY', '/shop/get_plan');
		const { balance_used } = planResponse;
		setCurrentPlan(
			balance_used === 0
				? 0
				: plans.findIndex(({ real_price }) => applyDiscount(real_price).toString() === (balance_used + applyDiscount(7.99)).toFixed(2))
		);
		setPlan(planResponse);
		setLoading(false);
	};

	useEffect(() => {
		getPlan();
	}, []);

	return (
		<Page background="white" header={{ title: 'Your Plan' }}>
			{loading && (
				<>
					<Spinner />
					<Loading />
				</>
			)}
			{!loading && plan && (
				<>
					<div className={classNames('mb-4 rounded bg-white mx-auto w-1/2')}>
						<div className={classNames('flex items-start  border-b p-3 font-bold text-sm')}>
							<label className={classNames('flex-1 capitalize text-gray-600')}>Current Plan</label>
							<div className={classNames('w-40 text-gray-700')}>
								<p>{plans[currentPlan].description}</p>
							</div>
						</div>
						<div className={classNames('flex items-start  border-b p-3 font-bold text-sm')}>
							<label className={classNames('flex-1 capitalize text-gray-600')}>
								Amount To Be Charged
							</label>
							<div className={classNames('w-40 text-gray-700')}>
								<p
									dangerouslySetInnerHTML={{
										__html: `$${(plan.balance_used + applyDiscount(7.99)).toFixed(2)}${
											// plan.balance_used > 0
											// 	? ` <span class='mu-text-xs mu-text-gray-500'>(${plans[currentPlan].description})</span>`
											// 	: ''
											''
											}`,
									}}
								/>
							</div>
						</div>
						<div className={classNames('flex items-center  border-b p-3 font-bold text-sm')}>
							<label className={classNames('flex-1 capitalize text-gray-600')}>Status</label>
							<div className={classNames('w-40 text-gray-700')}>
								<p>{plan.status}</p>
							</div>
						</div>
						<div className={classNames('flex items-center  border-b p-3 font-bold text-sm')}>
							<label className={classNames('flex-1 capitalize text-gray-600')}>Billing Date</label>
							<div className={classNames('w-40 text-gray-700')}>
								<p>{plan.billing_on ? moment(plan.billing_on).format('MMM Do YYYY') : 'Not Set'}</p>
							</div>
						</div>
						<div className={classNames('flex items-center   p-3 font-bold text-sm')}>
							<label className={classNames('flex-1 capitalize text-gray-600')}>
								Transactions This Month
							</label>
							<div className={classNames('w-40 text-gray-700')}>
								<p>{shop.transactions}</p>
							</div>
						</div>
					</div>
					<div className={classNames('flex-center p-3 mx-auto w-1/2')}>
						<a
							className={classNames('font-bold text-sm text-blue-500 hover:underline')}
							href="https://monsterapps.crisp.help/en/article/pricing-and-charges-1xt51rt/"
							target="_blank"
						>
							Visit our pricing page for more information
						</a>
					</div>
				</>
			)}
		</Page>
	);
};

export default PlanScreen;

// const Plan = ({ description, real_price, transactions, color, info, plan, active, loading = false }) => {
// 	const { state: shop } = useContext(ShopContext);
// 	return (
// 		<div className={classNames('w-1/4 px-2 h-full')} style={{ minWidth: 260 }}>
// 			<div
// 				key={description}
// 				className={classNames('py-2 px-3 mb-4 h-full bg-white border-t-4 shadow', `border-${color}`)}
// 			>
// 				<h2 className={classNames('flex-1 font-bold text-gray-700 text-xl mb-3')}>{description}</h2>
// 				<b className={classNames('flex-1 font-bold text-gray-600 text-lg mb-3')}>{`$${real_price} monthly`}</b>
// 				<ul className={classNames('list-none pt-6 pb-3')}>
// 					<li className={classNames('mb-3')}>
// 						<Icon icon="check" className="text-green-500 mr-2" />{' '}
// 						<span
// 							dangerouslySetInnerHTML={{
// 								__html: info,
// 							}}
// 						/>
// 					</li>
// 					{/* <li className={classNames('mb-3')}>
// 						<Icon icon="check" className="text-green-500 mr-2" /> Add To Unlock
// 					</li>
// 					<li className={classNames('mb-3')}>
// 						<Icon icon="check" className="text-green-500 mr-2" /> One Tick Upsell
// 					</li>
// 					<li className={classNames('mb-3')}>
// 						<Icon icon="check" className="text-green-500 mr-2" /> Buy More Save More
// 					</li>
// 					<li className={classNames('mb-3')}>
// 						<Icon icon="check" className="text-green-500 mr-2" /> Powerful Analytics
// 					</li> */}
// 					<li className={classNames('mb-3')}>
// 						<Icon icon="check" className="text-green-500 mr-2" /> All Other Features
// 					</li>
// 				</ul>

// 				{/* <button
// 					className={classNames(
// 						'w-full mt-4 font-bold text-sm p-2 rounded text-white focus:outline-none relative',
// 						{
// 							'cursor-not-allowed bg-gray-300': loading || auto_upgrade || active,
// 							[`text-${color}`]: active,
// 							[`bg-${color}`]: !auto_upgrade && !active && !loading,
// 						}
// 					)}
// 					disabled={loading || auto_upgrade || active}
// 					onClick={() => onSelect()}
// 				>
// 					<span
// 						className={classNames({
// 							'opacity-0': loading,
// 						})}
// 					>
// 						{active ? 'Current Plan' : `Choose ${description.replace(/ .* /, '')}`}
// 					</span>
// 					{loading && (
// 						<div className={classNames('absolute inset-0 flex-center', `text-${color}`)}>
// 							<Icon icon="spinner-third" spin />
// 						</div>
// 					)}
// 				</button> */}
// 			</div>
// 		</div>
// 	);
// };
